module.exports = __webpack_public_path__ + "images/about-tenant.10031d161bdb81f080d442d4aacbc9af.svg";